<div class="container">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="Meta de Governo"
            page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}" page-change="{{pagTitulo}}"
            show-change="true" image-title="assets/img/seo-report.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/metas-governo']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="form-group col-md-9">
              <label for="programa">Programa de governo</label>
              <input value="{{entidadeForm.get('programa.codigo').value}} {{entidadeForm.get('programa.nome').value}}"
                type="text" class="form-control-plaintext font-weight-bold" id="programa">
            </div>
            <div class="form-group col-md-3" *ngIf="tipo">
              {{tipo.nome}}
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12 pb-0 mb-0">
              <label for="unidade">Unidade administrativa</label>
              <input value="{{entidadeForm.get('unidade.codigo').value}} {{entidadeForm.get('unidade.nome').value}}"
                type="text" class="form-control-plaintext" id="unidade">
            </div>
          </div>
          <hr class="mt-3 mb-2" />
          <div class="form-row mb-0 pb-0">
            <div class="form-group col-12 pt-0 mt-0 mb-0 pb-0">
              <label for="funcao">Função Governo</label>
              <input value="{{entidadeForm.get('funcao.codigo').value}} {{entidadeForm.get('funcao.nome').value}}"
                type="text" class="form-control-plaintext" id="funcao">
            </div>
          </div>
          <div class="form-row pt-0 mt-0">
            <div class="form-group col-12 pt-0 mt-0">
              <label for="programa">Subfunção</label>
              <input value="{{entidadeForm.get('subfuncao.codigo').value}} {{entidadeForm.get('subfuncao.nome').value}}"
                type="text" class="form-control-plaintext" id="subfuncao">
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="gerente">Gerente do programa</label>
            <input value="{{entidadeForm.get('gerente').value}}"
                type="text" class="form-control-plaintext" id="subfuncao">
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Código</th>
                <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Indicador</th>
                <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Und.Medida</th>
                <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Recente</th>
                <th scope="col" rowspan="2" class="text-center" style="vertical-align: middle">Futuro</th>
                <th scope="col" colspan="4" class="text-center">Metas</th>
              </tr>
              <tr>
                <th scope="col" class="text-right">{{ano1}}</th>
                <th scope="col" class="text-right">{{ano2}}</th>
                <th scope="col" class="text-right">{{ano3}}</th>
                <th scope="col" class="text-right">{{ano4}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of indicadorLista">
                <th scope="row" class="text-center">{{item.codigo}}</th>
                <td>{{item.nome}}</td>
                <td class="text-center">{{item.unidade_medida}}</td>
                <td class="text-center">{{item.recente}}</td>
                <td class="text-center">{{item.futuro}}</td>
                <td class="text-right">{{item.meta1}}</td>
                <td class="text-right">{{item.meta2}}</td>
                <td class="text-right">{{item.meta3}}</td>
                <td class="text-right">{{item.meta4}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <pre *ngIf="entidadeForm">{{ entidadeForm | json}}</pre> -->
    </form>
  </div>
</div>